
export const capitalizeFirstLetter = (string: string): any => {
    return string?.length > 0 ? string.charAt(0).toUpperCase() + string.slice(1) : '';
}